import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import bgImage from "./assets/bg1.png"


function App({ userId }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [submitted, setSubmitted] = useState(false);

  const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];

  console.log("this is the userid", userId);
  const navigate = useNavigate();
  const schema = yup.object().shape({
    // Validations for name, last name, and father's name
    name: yup.string().required("Name is required"),

    LastName: yup.string().required("Last Name is required"),

    fatherName: yup.string().required("Father's Name is required"),

    // Validation for addresses
    Current_Address: yup.string().required("Current Address is required"),

    Permanent_Address: yup.string().required("Permanent Address is required"),

    // Validation for Date of Birth
    dob: yup.date().required("Date of Birth is required"),

    // Contact validation (10 digits as explained before)
    Contact: yup
      .number()
      .typeError("Contact No. must be a number") // Handle type errors
      .required("Contact No. is required") // Field is required
      .integer("Contact No. must be an integer") // Must be an integer
      .test(
        "len",
        "Contact No. must be exactly 10 digits",
        (val) => val && String(val).length === 10
      ),

    // Validation for Signature_Employee with supported file types
    profilePic: yup
      .mixed()
      .test("fileFormat", "Only JPG, PNG files are allowed", (value) =>
        value && value.length ? SUPPORTED_FORMATS.includes(value[0].type) : true
      )
      .required("profilePic is required"),

   
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("No token found, please login again.");
      navigate("/SignInCandidate");
    }
  }, [navigate]);

  const onSubmit = async (data) => {
    if (!userId) {
      alert("Please provide userId: " + userId);
      return;
    }

    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("LastName", data.LastName);
    formData.append("fatherName", data.fatherName);
    formData.append("Contact", data.Contact);
    formData.append("Current_Address", data.Current_Address || "");
    formData.append("Permanent_Address", data.Permanent_Address || "");
    formData.append("dob", data.dob);
    formData.append("cpic", data.profilePic[0]);
    formData.append("email", data.email);
    // formData.append("ProfilePic", data.ProfilePic[0]);
    formData.append("userId", userId);

    const token = localStorage.getItem("token")
      ? `Bearer ${localStorage.getItem("token")}`
      : null;

    try {
      const response = await fetch(
        "   http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/personalDetails",
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: token || "",
          },
        }
      );

      if (response.ok) {
        toast.success("Personal Details Submitted Successfully!", {
          position: "top-center",
          transition: Slide,
        });

        // Log the response for debugging
        console.log("Form submitted successfully");

        // Clear form
        reset();

        // Set submitted flag to true
        setSubmitted(true);

        // Delay navigation slightly to allow toast to show
        setTimeout(() => {
          navigate("/EnteryCandidatePortel/Qualifications");
        }, 1000); // 1 second delay
      } else {
        const errorMessage = await response.text();
        console.error("Failed to submit form:", errorMessage);
        toast.error("Failed to submit form. Please try again later.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to submit form. Please try again later.");
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <>
      <div
        className="w-full "
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* <Header /> */}
        <div className="flex justify-center items-center min-h-screen ">
          <div className="space-y-6 p-6 rounded-md">
          <form
                onSubmit={handleSubmit(onSubmit)}
              className="max-w-4xl mx-auto p-6 md:p-10  shadow-lg rounded-lg bg-gray-50 "
            >
              <h1 className="w-full text-3xl font-serif font-bold text-center my-6 text-indigo-600 ">
                Personal Details
              </h1>
              <div className="w-full border-b-2 border-indigo-400 mb-4  "></div>

              <div className="space-y-4">
                <div className="flex flex-wrap">
                  <div className=" gap-3 flex justify-center w-full">
                    <div className="w-full   px-2 ">
                      <div className="space-y-2">
                        <p className="block text-sm font-serif text-black text-center mt-3 font-bold mt-4">
                          First Name
                        </p>
                        <input
                          type="text"
                          placeholder="Your answer"
                          {...register("name")}
                          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                        />
                        {errors.name && (
                          <p className="text-red-500 text-md italic">
                            {errors.name.message}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="w-full   px-2 ">
                      <div className="space-y-2">
                        <p className="block text-sm font-serif text-black text-center mt-3 font-bold mt-4">
                          Last Name
                        </p>
                        <input
                          type="text"
                          placeholder="Your answer"
                          {...register("LastName")}
                          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                        />
                        {errors.name && (
                          <p className="text-red-500 text-md italic">
                            {errors.name.message}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="w-full  px-2 mt-2">
                      <div className="space-y-2">
                        <p className="block text-sm  font-serif text-center text-black mt-3 font-bold">
                          Father’s Name
                        </p>
                        <input
                          type="text"
                          placeholder="Your answer"
                          {...register("fatherName")}
                          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                        />
                        {errors.fatherName && (
                          <p className="text-red-500 text-md italic">
                            {errors.fatherName.message}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="w-full mt-2 px-2">
                      <div className="space-y-2">
                        <p className="block text-sm font-serif text-center text-black mt-3 font-bold">
                          Contact
                        </p>

                        <input
                          type="text"
                          placeholder="Your answer"
                          {...register("Contact")}
                          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                        />

                        {errors.Contact && (
                          <p className="text-red-500 text-md italic">
                            {errors.Contact.message}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="w-full mt-2 px-2">
                      <div className="space-y-2">
                        <p className="block text-sm font-serif text-center text-black mt-3 font-bold">
                          DOB
                        </p>
                        <input
                          type="date"
                          {...register("dob")}
                          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                        />
                        {errors.dob && (
                          <p className="text-red-500 text-md italic">
                            {errors.dob.message}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className=" flex mt-3 w-full gap-6">
                    <div className="w-full px-2">
                      <div className="space-y-2">
                        <p className="block text-sm w-full    font-serif mx-24 text-black mt-3 font-bold">
                          Current Address
                        </p>
                        <textarea
                          placeholder="Your answer"
                          {...register("Current_Address")}
                          className="w-full px-3 py-2 h-20 border rounded-md focus:outline-none focus:border-indigo-500"
                          rows={4}
                        />
                        {errors.Current_Address && (
                          <p className="text-red-500 text-md italic">
                            {errors.Current_Address.message}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="w-full px-2 ">
                      <div className="space-y-2">
                        <p className="block text-sm font-serif mx-24  text-black mt-3 font-bold">
                          Permanent Address
                        </p>
                        <textarea
                          type="text"
                          placeholder="Your answer"
                          {...register("Permanent_Address")}
                          className="w-full px-3 py-2 border h-20 rounded-md focus:outline-none focus:border-indigo-500"
                        />
                        {errors.Permanent_Address && (
                          <p className="text-red-500 text-md italic">
                            {errors.Permanent_Address.message}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className=" flex w-full mt-3 gap-6">
                    <div className="w-full px-2 ">
                      <div className="space-y-2">
                        <p className="block text-sm font-serif mx-24 text-black mt-3 font-bold">
                          Profile Pic
                        </p>
                        <input
                          type="file"
                          {...register("profilePic")}
                          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                        />
                        {errors.profilePic && (
                          <p className="text-red-500 text-md italic">
                            {errors.profilePic.message}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="w-full px-2">
                      <div className="space-y-2">
                        <p className="block text-sm font-serif mx-24 text-black mt-3 font-bold">
                          Gmail-Id
                        </p>
                        <input
                          type="email"
                          {...register("email")}
                          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                        />
                        {errors.email && (
                          <p className="text-red-500 text-md italic">
                            {errors.email.message}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-full flex justify-center mt-10">
                    <button
                      type="submit"
                      className="w-28 py-2 px-4 bg-green-600 text-white rounded-md mt-14 font-bold"
                    >
                      Submit
                    </button>
                  </div>

              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default App;
